<footer class="footer text-center py-2">
    <small class="text-muted">Powered By <span >MOTORI</span> 2024</small>
  </footer>